<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Central Matching Report
    </hero-bar>
    <section class="section is-main-section enable-select-text">
      <div class="level no-margin">
        <div class="level-left bulk-actions">
          <span class="navbar-item">
            <a @click.prevent="exportBarcodeMatching()" data-cy="pd-bulk-export"
              >Export</a
            >
          </span>
          <span class="navbar-item" v-if="isEditAllowed">
            <a
              @click.prevent="additionalBulkOps('apply')"
              data-cy="pd-bulk-edit"
              >Include</a
            >
          </span>
          <span class="navbar-item" v-if="isEditAllowed">
            <a
              @click.prevent="additionalBulkOps('exclude')"
              data-cy="pd-bulk-edit"
              >Exclude</a
            >
          </span>
        </div>
        <div class="level-right">
          <b-dropdown position="is-bottom-left">
            <template #trigger>
              <a class="navbar-item navbar-mdi-tune-dropdown" slot="trigger">
                <button class="button" data-cy="barcode-config-button">
                  <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
                </button>
              </a>
            </template>
            <form>
              <div class="filter-config-modal-body">
                <section class="filter-config-list">
                  <span>
                    <b-field label="Column Configuration"></b-field>
                  </span>
                  <div class="control">
                    <b-dropdown-item
                      aria-role="list"
                      :focusable="false"
                      custom
                      paddingless
                    >
                      <b-checkbox
                        @input="toggleAllColumns()"
                        v-model="selectAll"
                        class="pt-2"
                      >
                        <strong>Select All</strong>
                      </b-checkbox>
                    </b-dropdown-item>
                  </div>
                  <div
                    v-for="(column, index) in columns"
                    :key="index"
                    class="control"
                  >
                    <div v-if="column.label != '' && column.field != 'actions'">
                      <b-dropdown-item
                        aria-role="list"
                        :focusable="false"
                        custom
                        paddingless
                      >
                        <b-checkbox
                          @input="saveField()"
                          v-model="column.visible"
                        >
                          {{ column.label }}
                        </b-checkbox>
                      </b-dropdown-item>
                    </div>
                  </div>
                </section>
              </div>
            </form>
          </b-dropdown>
        </div>
      </div>
      <circul8-table
        @clickcheck="checkCheckBox"
        @checkedAll="checkedAllData"
        :checkedRows="checkedRow"
        :records="data"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :isCheckable="true"
        :maxTextLength="'48'"
        :isLoading="isDataLoading"
        :showEditButton="false"
        :backendSortingEnabled="true"
        :routeNext="false"
        :showRemoveButton="false"
        :showViewButton="false"
        @clickEdit="clickEditBarcodeMatch"
        @clickView="viewBarcodeMatch"
        @clickDelete="deleteModal"
        @backendSort="sortData"
        @querySet="searchByFilter"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        :allCustomers="customers"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
          {{
            currentPage > 0
              ? nextPageCursor
                ? currentPage * 50 - 50 + data.length
                : totalRecords
              : data.length
          }}
          records out of {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import Circul8Table from "../../components/Circul8Table.vue";
import DataManagementService from "../../services/DataManagementImportService";
import CustomerDataService from "@/services/CustomerProfileDataService";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { UserGroup } from "@/services/UserGroups";
import * as dayjs from "dayjs";

export default {
  name: "BarcodeMatching",
  mixins: [UtilityMixin, ScopeMixin],
  components: {
    HeroBar,
    TitleBar,
    Circul8Table
  },
  data() {
    return {
      data: [],
      checkedData: [],
      checkedRow: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      isDataLoading: false,
      selectAll: true,
      tblName: "BarcodeMatching",
      query: "",
      isModalActive: false,
      action: null,
      isAdd: false,
      exportLargeCount: 65000,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      // Prevent overlapping API calls; queue next attempt after 1s
      isFetchInProgress: false,
      fetchQueueTimer: null,
      nextData: false,
      previousData: false,
      currentPage: 0,
      customers: [],
      columns: [
        {
          field: "customer_name",
          label: "Customer Name",
          searchable: true,
          width: "200",
          type: "multiSelectFilter",
          visible: true,
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "additional_info",
          allStatusVals: this.customers,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { customer_name: [] }
        },
        {
          field: "t_product_number",
          label: "Transaction Product Number",
          searchable: true,
          visible: true,
          filterKey: { t_product_number: "" },
          type: "input"
        },
        {
          field: "t_product_model",
          label: "Transaction Product Model",
          searchable: true,
          visible: true,
          filterKey: { t_product_model: "" },
          type: "input"
        },
        {
          field: "ean",
          label: "Transaction EAN",
          searchable: true,
          visible: true,
          filterKey: { ean: "" },
          type: "input"
        },
        {
          field: "already_matched_product_number",
          label: "Already Matched Product Number",
          searchable: true,
          visible: true,
          filterKey: { already_matched_product_number: "" },
          type: "input"
        },
        {
          field: "already_matched_product_ean",
          label: "Already Matched Product EAN",
          searchable: true,
          visible: true,
          filterKey: { already_matched_product_ean: "" },
          type: "input"
        },
        {
          field: "already_matched_product_model",
          label: "Already Matched Product Model",
          searchable: true,
          visible: true,
          filterKey: { already_matched_product_model: "" },
          type: "input"
        },
        {
          field: "newly_matched_product_number",
          label: "Newly Matched Product Number",
          searchable: true,
          visible: true,
          filterKey: { newly_matched_product_number: "" },
          type: "input"
        },
        {
          field: "newly_matched_product_ean",
          label: "Newly Matched Product EAN",
          searchable: true,
          visible: true,
          filterKey: { newly_matched_product_ean: "" },
          type: "input"
        },
        {
          field: "apply_match",
          label: "Apply Match",
          width: "200",
          searchable: true,
          visible: true,
          searchKey: "apply_match",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: [{ name: "True" }, { name: "False" }],
          filterKey: {
            apply_match: [],
            field_name: "name"
          }
        },
        {
          field: "exclude_match",
          label: "Exclude Match",
          width: "200",
          searchable: true,
          visible: true,
          searchKey: "exclude_match",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: [{ name: "True" }, { name: "False" }],
          filterKey: {
            exclude_match: [],
            field_name: "name"
          }
        },
        {
          field: "newly_matched_product_model",
          label: "Newly Matched Product Model",
          searchable: true,
          visible: true,
          filterKey: { newly_matched_product_model: "" },
          type: "input"
        },
        {
          field: "updated_at",
          label: "Last Updated",
          searchable: true,
          visible: true,
          filterKey: { updated_at: "" },
          type: "dateField"
        },
        {
          field: "created_at",
          label: "Created At",
          searchable: true,
          visible: true,
          filterKey: { created_at: "" },
          type: "dateField"
        },
        {
          field: "actions",
          sortable: 1,
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      customerDataService: new CustomerDataService(),
      DataManagementService: new DataManagementService()
    };
  },
  mounted() {
    // check if columns are saved in the custom configuration then fetch them
    if (localStorage.getItem("barcodeMatchingFields")) {
      const visibleFields = JSON.parse(
        localStorage.getItem("barcodeMatchingFields")
      );
      this.columns.forEach(
        c => (c.visible = visibleFields.indexOf(c.field) >= 0)
      );
    }
    // get the saved query from localStorage
    if (localStorage.getItem(this.tblName + "Query")) {
      this.query = localStorage.getItem(this.tblName + "Query");
      // Populate filter values from the saved query
      this.populateFiltersFromQuery(this.query);
    }
    this.fetchCustomerData();
    this.fetchBarcodeMatchingData(this.query);
    this.checkExternalPermission();
  },
  beforeDestroy() {
    if (this.fetchQueueTimer) {
      clearTimeout(this.fetchQueueTimer);
      this.fetchQueueTimer = null;
    }
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        {
          url: "/DataManagement/BarcodeMatching",
          name: "Central Matching Report"
        }
      ];
    },
    isEditAllowed() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    customers: function(newVal, oldVal) {
      // Update the customer_name column's allStatusVals when customers data changes
      const customerColumn = this.columns.find(
        column => column.field === "customer_name"
      );
      if (customerColumn) {
        customerColumn.allStatusVals = newVal;
      }
    }
  },
  methods: {
    fetchCustomerData() {
      this.isDataLoading = true;
      this.customerDataService.getCustomerList().subscribe(
        response => {
          const data = response.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.customers = data;
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    getClearFormObject() {
      // Return a default object for editObject
      return {
        customer_name: "",
        t_product_number: "",
        t_product_model: "",
        updated_at: "",
        created_at: "",
        actions: false
      };
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.data);
      }
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexes = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.data.findIndex(object => {
          return element.id === object.id;
        });
        indexes.push(index);
      });
      // create 2 dictionary. one with indexes for showing current page selected another with checked row value
      this.map1.set(this.currentPage, indexes);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
    },
    additionalBulkOps(action) {
      if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select at least one Record to apply this action.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
      if (this.checkedData.length > 0 || this.isCheckedAll) {
        this.DataManagementService.bulkOperation(
          this.checkedData.map(records => records.id),
          this.isCheckedAll,
          action,
          this.query
        ).subscribe(response => {
          this.data = [];
          this.checkedData = [];
          this.checkedRow = [];
          this.checkedDataMap = new Map();
          this.map1 = new Map();
          this.isCheckedAll = false;
          this.fetchBarcodeMatchingData(this.query);
          this.$buefy.dialog.alert({
            title: "Success",
            message: `Bulk operation ${
              action == "apply" ? "Include" : "Exclude"
            } completed successfully.`,
            type: "is-success",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        });
      }
    },
    clickEditBarcodeMatch(row) {
      // Implement edit logic here
      // For now, just log
      console.log("Edit rule", row);
    },
    viewBarcodeMatch(row) {
      // Implement view logic here
      console.log("View rule", row);
    },
    deleteModal(row) {
      // Implement delete logic here
      console.log("Delete rule", row);
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["already_matched_product_number"] =
          reportData["already_matched_product_info"]?.product_number ?? "";
        reportData["already_matched_product_model"] =
          reportData["already_matched_product_info"]?.product_model ?? "";
        reportData["already_matched_product_ean"] =
          reportData["already_matched_product_info"]?.ean ?? "";
        reportData["newly_matched_product_number"] =
          reportData["newly_matched_product_info"]?.product_number ?? "";
        reportData["newly_matched_product_model"] =
          reportData["newly_matched_product_info"]?.product_model ?? "";
        reportData["newly_matched_product_ean"] =
          reportData["newly_matched_product_info"]?.ean ?? "";
        reportData["updated_at"] = dayjs(reportData["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        reportData["created_at"] = dayjs(reportData["created_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        reportData["actions"] = this.isEditAllowed;
        reportData["delete"] = this.isEditAllowed;
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.data.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.data = dataList;
      }
      this.isDataLoading = false;
    },
    pullNextPage() {
      if (!this.nextPageCursor) {
        return;
      }
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      this.query =
        "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      this.fetchBarcodeMatchingData(this.query, "next");
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchBarcodeMatchingData(this.query, "prev");
    },
    searchByFilter(filterQuery) {
      try {
        this.isDataLoading = true;
        this.nextPageCursor = null;
        this.currentPage = 0;
        this.data = [];
        this.nextData = false;
        this.query = "&" + filterQuery;

        // Save the query to localStorage
        if (filterQuery) {
          localStorage.setItem(this.tblName + "Query", this.query);
        } else {
          localStorage.removeItem(this.tblName + "Query");
        }

        let query = "";
        if (this.lastSortColumn) {
          query += "&order_field" + "=" + this.lastSortColumn;
          query += "&order_by" + "=" + this.lastSortOrder;
          query += this.query;
        } else {
          query = this.query;
        }
        this.fetchBarcodeMatchingData(query);
      } catch (e) {
        console.error("Error in searchByFilter:", e);
        this.isDataLoading = false;
        this.$buefy.toast.open({
          message: "Error applying filter",
          type: "is-danger"
        });
      }
    },
    sortData(field, order) {
      try {
        this.isDataLoading = true;
        this.loadMoreClicked = false;
        this.nextPageCursor = null;
        this.currentPage = 0;
        this.data = [];
        this.nextData = false;
        // sort should always fetch page 1, so removing page param if exist
        this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
        const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
        const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
        const newOrderField = "&order_field" + "=" + field;
        const newOrderValue = "&order_by" + "=" + order;

        this.query = this.replaceOrAddParanInSearchQuery(
          oldOrderField,
          newOrderField
        );
        this.query = this.replaceOrAddParanInSearchQuery(
          oldOrderValue,
          newOrderValue
        );

        this.lastSortColumn = field;
        this.lastSortOrder = order;
        this.fetchBarcodeMatchingData(this.query);
      } catch (e) {
        console.error("Error in sortData:", e);
        this.isDataLoading = false;
        this.data = [];
        this.$buefy.toast.open({
          message: "Error sorting data",
          type: "is-danger"
        });
      }
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      try {
        if (this.query && this.query.includes(oldParam)) {
          this.query = this.query.replace(oldParam, newParam);
        } else {
          this.query = (this.query || "") + newParam;
        }
        return this.query;
      } catch (e) {
        console.error("Error in replaceOrAddParanInSearchQuery:", e);
        return this.query || "";
      }
    },
    fetchBarcodeMatchingData(query = "", scrollDir) {
      // If a request is in-flight, defer new ones by 1s and try again
      if (this.isFetchInProgress) {
        if (this.fetchQueueTimer) {
          clearTimeout(this.fetchQueueTimer);
        }
        this.fetchQueueTimer = setTimeout(() => {
          this.fetchQueueTimer = null;
          // Only retry if nothing else started in the meantime
          this.fetchBarcodeMatchingData(query, scrollDir);
        }, 1000);
        return;
      }

      this.isFetchInProgress = true;
      this.isLoading = true;
      //this.data = [];
      this.DataManagementService.getBarcodeMatchingData(query).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            //this.totalRecords = this.data.length + response["count"];
            if (!this.nextPageCursor) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...this.data, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.data];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"]);
          }
          this.isLoading = false;
          this.isFetchInProgress = false;
        },
        e => {
          this.handleApiError(e);
          this.isLoading = false;
          this.isDataLoading = false;
          this.nextData = false;
          this.isFetchInProgress = false;
        }
      );
    },
    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }

      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.isDataLoading = false;
      this.isLoading = false;
    },
    saveField() {
      localStorage.setItem(
        "barcodeMatchingFields",
        JSON.stringify(this.columns.filter(c => c.visible).map(c => c.field))
      );
    },
    toggleAllColumns() {
      this.columns.forEach(column => {
        if (column.field !== "actions") {
          column.visible = this.selectAll;
        }
      });
      this.saveField();
    },
    populateFiltersFromQuery(query) {
      if (!query) {
        return;
      }

      // Parse the query string to extract filter parameters
      const params = new URLSearchParams(query.replace(/^&/, ""));

      // Iterate through each column and populate filterKey values
      this.columns.forEach(column => {
        if (column.filterKey) {
          if (column.type === "multiSelectFilter") {
            // For multiselect filters, get all values with the field name
            const values = params.getAll(column.field);
            if (values.length > 0) {
              column.filterKey[column.field] = values;
            }
          } else if (column.type === "dateField") {
            // For date fields, check for the filter key pattern
            const value = params.get(column.field);
            if (value) {
              column.filterKey[column.field] = value;
            }
          } else {
            // For input fields
            const value = params.get(column.field);
            if (value) {
              column.filterKey[column.field] = value;
            }
          }
        }
      });
    },
    exportBarcodeMatching() {
      let msg = ``;
      if (this.isCheckedAll) {
        msg = `Are you sure you want to export all records?`;
      } else {
        msg =
          `Are you sure you want to export selected ` +
          this.checkedData?.length +
          ` records?`;
      }

      if (this.isCheckedAll && this.totalRecords > this.exportLargeCount) {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      } else if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select at least one Record",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
      if (this.checkedData.length || this.isCheckedAll) {
        try {
          this.$buefy.dialog.confirm({
            title: "Confirmation",
            confirmText: "Yes",
            message: msg,
            trapFocus: true,
            onConfirm: value => this.exportBarcodeMatchingService()
          });
        } catch (e) {
          if (e == "invalid") {
            this.isCheckedAll = false;
            this.checkedDataMap = new Map();
            this.checkedData = [];
            this.checkedRow = [];
            this.map1 = new Map();
          }
        }
      }
    },
    exportBarcodeMatchingService() {
      this.isDataLoading = true;
      let checkedRecord = this.checkedData.map(records => records.id);
      if (this.isCheckedAll) {
        checkedRecord = [];
      }
      try {
        this.DataManagementService.exportBarcodeMatching(
          checkedRecord,
          this.isCheckedAll,
          this.query
        );
        this.isDataLoading = false;
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    }
  }
};
</script>
